<template>
  <DialogTemplateToolkit
    class-name="low-balance-dialog"
    :data-qa="'low-balance-dialog'"
    :dialog="dialog"
    footer_class="pt-4"
    :title="$t('User.YourBalanceIsLow')"
    without_first_btn
    without_second_btn
    @close="close">
    <template #card-text>
      <div
        class="h7-text py-5">
        <div>{{ $t('User.WorkOnSiteWillBeImpossible.0') }}</div>
        <div>{{ $t('Common.DateFrom') }} <span class="bold">{{ date }}</span> {{ $t('User.WorkOnSiteWillBeImpossible.1') }}</div>
      </div>
      <div class="pa-0">
        <div class="h9-label pb-1">
          {{ $t('User.CurrentBalance') }}
        </div>
        <div
          class="text-left h7-text"
          data-qa="low-balance-dialog-summ">
          {{ settings ? settings.balance : 0 }} {{ $t('Tenders.hrn') }}
        </div>
      </div>
    </template>
    <template #first_btn>
      <CreateInvoiceDialog
        data-qa="low-balance-dialog-create-invoice"
        mode="black-button"
        @close="close"/>
    </template>
  </DialogTemplateToolkit>
</template>
<script>
import CreateInvoiceDialog from 'components/billing/CreateInvoiceDialog.vue'
import DialogTemplateToolkit from 'components/common/dialogs/DialogTemplateToolkit.vue'

import moment from 'moment'

import { mapGetters } from 'vuex'

export default {
  name: 'lowBalanceDialog',
  data() {
    return {
      dialog: false,
      date: moment().format('DD.MM.YYYY'),
    }
  },
  computed: {
    ...mapGetters({
      settings: 'getSettings',
    }),
  },
  methods: {
    close() {
      this.$emit('update:show', false)
    },
  },
  watch: {
    show: {
      immediate: true,
      handler(newValue) {
        if (newValue) {
        
          this.date = moment(moment().format('M'), 'M')
            .add(this.settings.userAccess?.checkBillingResult?.delayDays, 'days').format('DD.MM.YYYY')
          this.dialog = true
        } else {
          this.dialog = false
        }
      }
    }
  },
  props: {
    show: {
      type: Boolean
    }
  },
  components: {
    CreateInvoiceDialog,
    DialogTemplateToolkit
  }
}
</script>
